(() => {
  if (window.MascraftDiscreetPackagingLoaded) return;
  window.MascraftDiscreetPackagingLoaded = true;

  const containerSelector = '[data-discreet-packaging]';
  const checkboxSelector = '[data-discreet-packaging-checkbox]';
  let saving = false;

  const sync = (container, value) => {
    const checkbox = container.querySelector(checkboxSelector);
    const attribute = container.querySelector('[data-discreet-packaging-attribute]');
    attribute.value = value;
    checkbox.checked = value === checkbox.value;
  };

  document.addEventListener('change', async (event) => {
    if (!event.target.matches(checkboxSelector)) return;
    if (saving) return;

    const container = event.target.closest(containerSelector);
    const checkbox = event.target;
    const attribute = container.querySelector('[data-discreet-packaging-attribute]');
    const previousValue = attribute.value;
    const value = checkbox.checked ? checkbox.value : checkbox.dataset.uncheckedValue;
    const sourceId = checkbox.id;

    saving = true;
    document.querySelectorAll(containerSelector).forEach((item) => {
      sync(item, value);
      item.querySelector('[data-discreet-packaging-error]').hidden = true;
      item.setAttribute('aria-busy', 'true');
      item.querySelector(checkboxSelector).disabled = true;

      const checkout = item.closest('form').querySelector('[name="checkout"]');
      if (checkout && !checkout.disabled) {
        checkout.disabled = true;
        checkout.dataset.discreetPackagingPending = '';
      }
    });

    const formData = new FormData();
    formData.append(attribute.name, value);
    let saved = false;

    try {
      const updateUrl = `${window.Shopify.routes.root}cart/update.js`;
      const requestOptions = {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      };
      let response = await fetch(updateUrl, requestOptions);
      if (response.status === 404 && updateUrl !== '/cart/update.js') {
        response = await fetch('/cart/update.js', requestOptions);
      }
      if (!response.ok) throw new Error('Cart attribute update failed');

      const cart = await response.json();
      if (cart.attributes?.[container.dataset.attributeKey] !== value) {
        throw new Error('Cart attribute was not saved');
      }
      saved = true;
    } catch (_error) {
      saved = false;
    } finally {
      document.querySelectorAll(containerSelector).forEach((item) => {
        sync(item, saved ? value : previousValue);
        item.querySelector('[data-discreet-packaging-error]').hidden = saved || item.querySelector(checkboxSelector).id !== sourceId;
        item.querySelector(checkboxSelector).disabled = false;
        item.removeAttribute('aria-busy');

        const checkout = item.closest('form').querySelector('[name="checkout"]');
        if (checkout && checkout.hasAttribute('data-discreet-packaging-pending')) {
          checkout.disabled = false;
          checkout.removeAttribute('data-discreet-packaging-pending');
        }
      });
      saving = false;
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-discreet-packaging-info]');
    document.querySelectorAll('[data-discreet-packaging-info]').forEach((button) => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      const nextOpen = button === trigger && !isOpen;
      button.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      if (button === trigger) button.toggleAttribute('data-discreet-packaging-dismissed', !nextOpen);
    });
  });

  document.addEventListener('pointerout', (event) => {
    const trigger = event.target.closest('[data-discreet-packaging-info]');
    if (trigger && !trigger.contains(event.relatedTarget)) {
      trigger.removeAttribute('data-discreet-packaging-dismissed');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-discreet-packaging-info][aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('data-discreet-packaging-dismissed', '');
    });
  });
})();
